import { PackageStatusType, statusNormalizeMap } from '@well/delivery-libs/packages/domain';
import { Maybe } from '@irian-ro/util-functions';

export class PackageStatusUtils {
  static normalize(statusType: Maybe<PackageStatusType>): string {
    return statusNormalizeMap.get((statusType ?? '') as PackageStatusType) ?? 'PROGRESS';
  }

  static colorClass(statusType: Maybe<PackageStatusType>): string {
    return `${this.normalize(statusType).toLowerCase()}-color`;
  }
}
